import {
  TrashIcon,
  DownloadIcon,
  ReplaceIcon,
  AlignImageLeftIcon,
  AlignImageRightIcon,
  AlignImageCenterIcon,
  AlignFullWidthIcon,
} from "outline-icons";
import { EditorState } from "prosemirror-state";
import * as React from "react";
import isNodeActive from "../../../shared/editor/queries/isNodeActive";
import { MenuItem } from "../../../shared/editor/types";

export default function imageMenuItems(
  state: EditorState,
  // dictionary: Dictionary
): MenuItem[] {
  const { schema } = state;
  const isLeftAligned = isNodeActive(schema.nodes.image, {
    layoutClass: "left-50",
  });
  const isRightAligned = isNodeActive(schema.nodes.image, {
    layoutClass: "right-50",
  });
  const isFullWidthAligned = isNodeActive(schema.nodes.image, {
    layoutClass: "full-width",
  });

  return [
    {
      name: "alignLeft",
      tooltip: "Align left",
      icon: <AlignImageLeftIcon />,
      visible: true,
      active: isLeftAligned,
    },
    {
      name: "alignCenter",
      tooltip: "Align center",
      icon: <AlignImageCenterIcon />,
      visible: true,
      active: (state) =>
        isNodeActive(schema.nodes.image)(state) &&
        !isLeftAligned(state) &&
        !isRightAligned(state) &&
        !isFullWidthAligned(state),
    },
    {
      name: "alignRight",
      tooltip: "Align right",
      icon: <AlignImageRightIcon />,
      visible: true,
      active: isRightAligned,
    },
    {
      name: "alignFullWidth",
      tooltip: "Full width",
      icon: <AlignFullWidthIcon />,
      visible: true,
      active: isFullWidthAligned,
    },
    {
      name: "separator",
      visible: true,
    },
    {
      name: "downloadImage",
      tooltip: "Download image",
      icon: <DownloadIcon />,
      visible: !!fetch,
      active: () => false,
    },
    {
      name: "replaceImage",
      tooltip: "Replace image",
      icon: <ReplaceIcon />,
      visible: true,
      active: () => false,
    },
    {
      name: "deleteImage",
      tooltip: "Delete image",
      icon: <TrashIcon />,
      visible: true,
      active: () => false,
    },
  ];
}
